var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5290_3177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1339 3.51074C12.3349 3.51074 11.5977 3.24605 11.0058 2.79953C10.3268 2.28765 9.83899 1.5368 9.66673 0.671367C9.62407 0.457539 9.6011 0.236875 9.59891 0.0107422H7.31653V6.2473L7.3138 9.66335C7.3138 10.5766 6.71907 11.351 5.89466 11.6233C5.6554 11.7024 5.397 11.7398 5.12794 11.7251C4.7845 11.7062 4.46266 11.6026 4.18294 11.4352C3.58766 11.0792 3.18407 10.4333 3.17313 9.69452C3.1559 8.5398 4.08942 7.59835 5.24333 7.59835C5.4711 7.59835 5.68985 7.63554 5.89466 7.70308V5.99847V5.3857C5.67864 5.35371 5.4588 5.33703 5.23649 5.33703C3.97348 5.33703 2.79223 5.86203 1.94786 6.80784C1.30965 7.52261 0.92684 8.43452 0.867778 9.39073C0.790395 10.6469 1.25004 11.841 2.14145 12.722C2.27243 12.8514 2.40997 12.9714 2.55379 13.0821C3.31805 13.6703 4.25239 13.9891 5.23649 13.9891C5.4588 13.9891 5.67864 13.9727 5.89466 13.9407C6.81395 13.8046 7.66216 13.3837 8.33153 12.722C9.15403 11.9091 9.60848 10.8298 9.61341 9.68112L9.60165 4.57988C9.99403 4.88257 10.4231 5.13304 10.8835 5.32746C11.5997 5.6296 12.359 5.78273 13.1405 5.78245V4.12515V3.51019C13.141 3.51074 13.1345 3.51074 13.1339 3.51074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5290_3177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.00012207)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/tik-tok.3a84f90ee43c81ad0c43a6c8f2185756.svg";
export { ForwardRef as ReactComponent };